const {
  browserLocalPersistence,
  getAuth,
  setPersistence,
  signInWithEmailAndPassword,
  signOut,
} = require("firebase/auth")
const { getFirebaseClientApp } = require("./client")

let persistencePromise

function getAdminAuth() {
  return getAuth(getFirebaseClientApp())
}

function prepareAdminAuth() {
  if (!persistencePromise) {
    persistencePromise = setPersistence(
      getAdminAuth(),
      browserLocalPersistence
    ).catch(error => {
      persistencePromise = undefined
      throw error
    })
  }

  return persistencePromise
}

async function signInAdmin(email, password) {
  await prepareAdminAuth()
  return signInWithEmailAndPassword(getAdminAuth(), email, password)
}

function signOutAdmin() {
  return signOut(getAdminAuth())
}

module.exports = {
  getAdminAuth,
  prepareAdminAuth,
  signInAdmin,
  signOutAdmin,
}
